import styled from 'styled-components'
import { COLOR, FONT_SIZE } from '../../themes'
export const VALIDATE = styled.div`
    color: ${COLOR.RED_2};
    font-size: ${FONT_SIZE.XXS};
`
